import * as YoNetwork from './YoNetwork/YoNetwork.js'

export default {
  CreateRoom: require('./CreateRoom/CreateRoom.vue').default,
  SearchRoom: require('./SearchRoom/SearchRoom.vue').default,
  Login: require('./Login/Login.vue').default,
  Logout: require('./Logout/Logout.vue').default,
  YourName: require('./YourName/YourName.vue').default,

  Dialogue: require('./Dialogue/Dialogue.vue').default,

  EmojiFlower: require('./EmojiFlower/EmojiFlower.vue').default,

  SenderService: require('./SenderService/SenderService.vue').default,
  DrawBoard: require('./SenderService/DrawBoard.vue').default,
  FabricBoard: require('./SenderService/FabricBoard.vue').default,
  TextInput: require('./SenderService/TextInput.vue').default,

  Stats: require('./Stats/Stats.vue').default,
  WordCloud: require('./WordCloud/WordCloud.vue').default,
  SearchArea: require('./SearchArea/SearchArea.vue').default,
  EnterPin: require('./EnterPin/EnterPin.vue').default,

  PollArea: require('./PollArea/PollArea.vue').default,
  MyScript: require('./MyScript/MyScript.vue').default,
  OnlineArea: require('./OnlineArea/OnlineArea.vue').default,

  dummy: {}
}

export const API = YoNetwork
export const Status = API.Status
